

import {fnExists} from './utils/fnexists'
import {
    hastouch, 
    mobileview, 
    browser
} from './utils/browserProfiler'    
import {preloader} from './ui/preloader'
import {sidebar} from './ui/sidebar'
import {modal} from './ui/modal'
import {iframemodal} from './ui/iframe-modal'
import {
    OpenWindow, 
    popup
} from './ui/popup'
import { 
    confirmForm, 
    confirmLink, 
    confirmSelect 
} from './ui/confirm'
import {currenturl} from './ui/currenturl'
import {messages} from './ui/messages'
import {
    MainMenu, MenuDown
} from './ui/menu'
import {sideLinks} from './ui/sidelinks'

// Expose
window.OpenWindow = OpenWindow;

// Register jQuery Fn
fnExists();

// Register messages
messages(); 

$(document).ready(() => {
    
    hastouch();
    mobileview();
    browser();
    
    sidebar();
    
    modal();
    iframemodal();
    popup();

    confirmForm();
    confirmLink();
    confirmSelect();
    
    currenturl();
    
    MainMenu();
    MenuDown();
    
    sideLinks();


});

$(window).on('load', () => {

    preloader();

});